import { unifiedApi } from "@/common";
import { ref } from "vue";
import { handleApiError } from "@/common/handleApiError";
import { IPendingVerificationEmailResponse } from "./api/unifiedPortal/interfaces";
import { logEvent } from "@/common/logger";
import { AxiosError } from "axios";

export const pendingVerificationEmail = ref<string>("");

/** Retrieves any pending email verifications so we can get the current email user is using */
export async function getPendingEmailVerification() {
  try {
    const getPendingVerificationResponse: IPendingVerificationEmailResponse = (
      await unifiedApi.getPendingVerificationEmail()
    ).data;

    pendingVerificationEmail.value = getPendingVerificationResponse.pendingEmail;
  } catch (error) {
    logEvent(`Resulted in not OK ${error}`, `${name}/getPendingVerification`);
    handleApiError(error as AxiosError);
  }
}
